import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {OpenItemReportModel} from "./open-item-report.model";

@Component({
    selector: "wbo-open-item-report",
    templateUrl: "./open-item-report.component.html",
    providers: [provideReportModel(OpenItemReportModel)]
})
export class OpenItemReportComponent extends AbstractReportPage {

    constructor(public model: OpenItemReportModel) {
        super();
    }
}
